import { PROJECT_FILTER_OPTIONS } from "./projectConstants";
import {
  SESSION_CLEARANCE_TYPE_OPTIONS,
  SESSION_PROJECT_STATUS_OPTIONS,
} from "./sessionConstants";
import { CENTRAL_PROJECT_TYPES } from "./centralConstants";
import { USER_STATUS_OPTIONS, USER_ROLES } from "./authConstants";

export const FILTER_CONFIGS = {
  PROJECT_APPROVAL: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
    {
      key: "sector",
      label: "Sector",
      component: "select",
      type: "sector",
      placeholder: "Select Sector",
      allLabel: "All Sectors",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "status",
      label: "Status",
      component: "select",
      type: "custom",
      options: PROJECT_FILTER_OPTIONS.status,
      placeholder: "Select Status",
      allLabel: "All Status",
    },
    {
      key: "sort",
      label: "Sort",
      component: "select",
      type: "custom",
      options: PROJECT_FILTER_OPTIONS.sort,
      placeholder: "Select Sorting",
      allLabel: "Default Sort",
    },
  ],

  PROJECT_HISTORY: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
    {
      key: "status",
      label: "Status",
      component: "select",
      type: "custom",
      options: PROJECT_FILTER_OPTIONS.status,
      placeholder: "Select Status",
      allLabel: "All Status",
    },
    {
      key: "sort",
      label: "Sort",
      component: "select",
      type: "custom",
      options: PROJECT_FILTER_OPTIONS.sort,
      placeholder: "Select Sorting",
      allLabel: "Default Sort",
    },
  ],

  DEPARTMENT_SUBMISSIONS: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search by department, file name, or uploader...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
  ],

  STATE_DEPARTMENTS: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search departments...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
      required: true,
    },
  ],

  SESSION_BUDGET: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search departments or sectors...",
      type: "search",
      inputType: "text",
    },
    {
      key: "sector",
      label: "Sector",
      component: "select",
      type: "sector",
      placeholder: "Select Sector",
      allLabel: "All Sectors",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
  ],

  SESSION_DESCRIPTIVE: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "clearanceType",
      label: "State Plan/Negotiated Loan",
      component: "select",
      type: "custom",
      options: SESSION_CLEARANCE_TYPE_OPTIONS,
      placeholder: "Filter by Clearance Type",
      allLabel: "All Clearance Types",
    },
    {
      key: "projectStatus",
      label: "Project Status",
      component: "select",
      type: "custom",
      options: SESSION_PROJECT_STATUS_OPTIONS,
      placeholder: "Filter by Project Status",
      allLabel: "All Project Status",
    },
  ],

  ONGOING_PROJECTS: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
    {
      key: "yearOfCommencement",
      label: "Year of Commencement",
      component: "select",
      type: "custom",
      options: (() => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= 1990; year--) {
          years.push({ value: year.toString(), label: year.toString() });
        }
        return years;
      })(),
      placeholder: "Select Year",
      allLabel: "All Years",
    },
  ],

  ONGOING_PROJECTS_FORM: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
      required: true,
    },
  ],

  PROJECT_ALLOCATION: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects or departments...",
      type: "search",
      inputType: "text",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
  ],

  CLEARANCE: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
  ],

  DEPARTMENTAL_ALLOCATION: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search departments...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
  ],

  CLEARANCE_DEPARTMENT_WISE: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search departments or sectors...",
      type: "search",
      inputType: "text",
    },
    {
      key: "sector",
      label: "Sector",
      component: "select",
      type: "sector",
      placeholder: "Select Sector",
      allLabel: "All Sectors",
    },
    {
      key: "department",
      label: "Department",
      component: "select",
      type: "department",
      placeholder: "Select Department",
      allLabel: "All Departments",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
  ],

  CENTRAL_OVERALL: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search projects...",
      type: "search",
      inputType: "text",
    },
    {
      key: "financialYear",
      label: "Financial Year",
      component: "select",
      type: "financialYear",
      placeholder: "Select Financial Year",
      allLabel: "All Financial Years",
    },
    {
      key: "projectType",
      label: "Project Type",
      component: "select",
      type: "custom",
      options: [
        { value: CENTRAL_PROJECT_TYPES.DONER, label: "DoNER" },
        { value: CENTRAL_PROJECT_TYPES.NEC, label: "NEC" },
      ],
      placeholder: "Select Project Type",
      allLabel: "All Project Types",
    },
    {
      key: "scheme",
      label: "Scheme",
      component: "select",
      type: "custom",
      options: [
        { value: "nesids-otri", label: "NLCPR/NESIDS (OTRI)" },
        { value: "pm-devine", label: "PM-DeVINE" },
        { value: "nesids-roads", label: "NESIDS (Roads)" },
        { value: "schemes-of-nec-sonec", label: "Schemes of NEC (SONEC)" },
        {
          value: "focus-development-component",
          label: "Focus Development Component",
        },
      ],
      placeholder: "Select Scheme",
      allLabel: "All Schemes",
    },
  ],

  USER_MANAGEMENT: [
    {
      key: "search",
      label: "Search",
      component: "input",
      placeholder: "Search users...",
      type: "search",
      inputType: "text",
    },
    {
      key: "status",
      label: "Status",
      component: "select",
      type: "custom",
      options: USER_STATUS_OPTIONS,
      placeholder: "Select Status",
      allLabel: "All Status",
    },
    {
      key: "sector",
      label: "Sector",
      component: "select",
      type: "sector",
      placeholder: "Select Sector",
      allLabel: "All Sectors",
    },
    {
      key: "role",
      label: "Role",
      component: "select",
      type: "custom",
      options: [
        { value: USER_ROLES.ADMIN, label: "Admin" },
        { value: USER_ROLES.DEPARTMENT, label: "Department User" },
        { value: USER_ROLES.PLANNING_OFFICIAL, label: "Planning Officials" },
        { value: USER_ROLES.DONER, label: "DoNER Officials" },
      ],
      placeholder: "Select Role",
      allLabel: "All Roles",
    },
    {
      key: "sort",
      label: "Sort",
      component: "select",
      type: "custom",
      options: [
        { value: "createdAt-desc", label: "Newest First" },
        { value: "createdAt-asc", label: "Oldest First" },
        { value: "name-asc", label: "Name A-Z" },
        { value: "name-desc", label: "Name Z-A" },
        { value: "status-asc", label: "Status A-Z" },
        { value: "status-desc", label: "Status Z-A" },
      ],
      placeholder: "Sort By",
      allLabel: "Default Sort",
    },
  ],
};

export const getFilterConfig = (configKey, options = {}) => {
  let config = FILTER_CONFIGS[configKey] || [];

  if (options.showDepartmentFilter === false) {
    config = config.filter((filter) => filter.key !== "department");
  }

  if (options.showSearch === false) {
    config = config.filter((filter) => filter.key !== "search");
  }

  if (options.isAdmin === false) {
    config = config.filter((filter) => !filter.adminOnly);
  }

  if (options.overrides) {
    config = config.map((filter) => {
      if (options.overrides[filter.key]) {
        return { ...filter, ...options.overrides[filter.key] };
      }
      return filter;
    });
  }

  return config;
};

export const getDefaultFilterValues = (configKey, options = {}) => {
  const config = getFilterConfig(configKey, options);
  const defaults = {};

  config.forEach((filter) => {
    defaults[filter.key] = filter.defaultValue || "";
  });

  return defaults;
};